import * as React from "react"
import { Helmet } from "react-helmet"
import Home from "../components/Home"

function IndexPage(props) {

    return <div>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Fabio Santo Mobile Product Engineer, design and development</title>
            <link rel="icon" href="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='0.9em' font-size='90'>👨‍💻</text></svg>" />
            <link rel="canonical" href="https://fabio.santo.dev" />
        </Helmet>
        <div className="index-body">
            {Home()}
        </div>
    </div>
}

export default IndexPage